var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.611,
    height: 19.45,
    viewBox: "0 0 19.611 19.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart-large-2-svgrepo-com",
    transform: "translate(0.95 0.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M2,3l.262.088c1.308.44,1.961.66,2.335,1.184s.374,1.219.374,2.611V9.5c0,2.828,0,4.243.87,5.121s2.271.879,5.073.879h7.924",
    transform: "translate(-2 -3)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M7.5,18A1.5,1.5,0,1,1,6,19.5,1.5,1.5,0,0,1,7.5,18Z",
    transform: "translate(-2.042 -3)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    d: "M16.5,18A1.5,1.5,0,1,1,15,19.5,1.5,1.5,0,0,1,16.5,18Z",
    transform: "translate(-2.161 -3)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M5,6H16.45c2.055,0,3.082,0,3.527.674s.04,1.619-.77,3.508l-.429,1c-.378.882-.567,1.323-.943,1.571A3.343,3.343,0,0,1,16.022,13H5",
    transform: "translate(-2.161 -3)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.f40d2bfac5eb9fc15b6d64f78e57562d.svg";
export { ForwardRef as ReactComponent };